<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        lg="4"
      >
        <base-material-chart-card
          :data="emailsSubscriptionChart.data"
          :options="emailsSubscriptionChart.options"
          :responsive-options="emailsSubscriptionChart.responsiveOptions"
          color="#E91E63"
          hover-reveal
          type="Bar"
        >
          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  color="info"
                  icon
                  v-on="on"
                >
                  <v-icon
                    color="info"
                  >
                    mdi-refresh
                  </v-icon>
                </v-btn>
              </template>

              <span>Refresh</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  light
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <span>Change Date</span>
            </v-tooltip>
          </template>

          <h4 class="card-title font-weight-light mt-2 ml-2">
            Website Views
          </h4>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">
            Last Campaign Performance
          </p>

          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">updated 10 minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col
        cols="12"
        lg="4"
      >
        <base-material-chart-card
          :data="kospiChart.data"
          :options="kospiChart.options"
          color="success"
          hover-reveal
          type="Line"
        >
          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  color="info"
                  icon
                  v-on="on"
                >
                  <v-icon
                    color="info"
                  >
                    mdi-refresh
                  </v-icon>
                </v-btn>
              </template>

              <span>Refresh</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  light
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <span>Change Date</span>
            </v-tooltip>
          </template>

          <h4 class="card-title font-weight-light mt-2 ml-2">
            Kospi 지수
          </h4>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">
            <v-icon color="red" small v-if="kospiChart.isTodayUp">
              mdi-arrow-up
            </v-icon>
            <v-icon color="green" small v-else>
              mdi-arrow-down
            </v-icon>
            <span class="green--text">{{kospiChart.todayRatio}}%</span>&nbsp;
            {{kospiChart.isTodayUp? '지수상승' : '지수하락'}}
          </p>

          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">updated 1 minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col
        cols="12"
        lg="4"
      >
        <base-material-chart-card
          :data="kosdaqChart.data"
          :options="kosdaqChart.options"
          hover-reveal
          color="info"
          type="Line"
        >
          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  color="info"
                  icon
                  v-on="on"
                >
                  <v-icon
                    color="info"
                  >
                    mdi-refresh
                  </v-icon>
                </v-btn>
              </template>

              <span>Refresh</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  light
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <span>Change Date</span>
            </v-tooltip>
          </template>

          <h3 class="card-title font-weight-light mt-2 ml-2">
            Kosdaq 지수
          </h3>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">
            <v-icon color="red" small v-if="kosdaqChart.isTodayUp">
              mdi-arrow-up
            </v-icon>
            <v-icon color="green" small v-else>
              mdi-arrow-down
            </v-icon>
            <span class="green--text">{{kosdaqChart.todayRatio}}%</span>&nbsp;
            {{kosdaqChart.isTodayUp? '지수상승' : '지수하락'}}
          </p>

          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">updated 1 minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="info"
          icon="mdi-twitter"
          title="Followers"
          value="+245"
          sub-icon="mdi-clock"
          sub-text="Just Updated"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="primary"
          icon="mdi-poll"
          title="Website Visits"
          value="75.521"
          sub-icon="mdi-tag"
          sub-text="Tracked from Google Analytics"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="success"
          icon="mdi-store"
          title="Revenue"
          value="$ 34,245"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="orange"
          icon="mdi-sofa"
          title="Bookings"
          value="184"
          sub-icon="mdi-alert"
          sub-icon-color="red"
          sub-text="Get More Space..."
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <base-material-card
          color="warning"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              오늘의 추천종목
            </div>

            <div class="subtitle-1 font-weight-light">
              [{{ today }}] 고가대비 하락종목, 우량종목
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="recommendStocks"
            />
          </v-card-text>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="warning"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              오늘의 거래량상위
            </div>

            <div class="subtitle-1 font-weight-light">
              [{{ workday }}] Sort by lowest PER
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="topTradingHeaders"
              :items="topTradingStocks"
            />
          </v-card-text>
          <span class="caption grey--text font-weight-light">{{ topTradingSearchTime }}</span>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <base-material-card class="px-5 py-3">
          <template v-slot:heading>
            <v-tabs
              v-model="tabs"
              background-color="transparent"
              slider-color="white"
            >
              <span
                class="subheading font-weight-light mx-3"
                style="align-self: center"
              >Tasks:</span>
              <v-tab class="mr-3">
                <v-icon class="mr-2">
                  mdi-bug
                </v-icon>
                Front
              </v-tab>
              <v-tab class="mr-3">
                <v-icon class="mr-2">
                  mdi-code-tags
                </v-icon>
                Backend
              </v-tab>
              <v-tab>
                <v-icon class="mr-2">
                  mdi-cloud
                </v-icon>
                Server
              </v-tab>
            </v-tabs>
          </template>

          <v-tabs-items
            v-model="tabs"
            class="transparent"
          >
            <v-tab-item
              v-for="n in 3"
              :key="n"
            >
              <v-card-text>
                <template v-for="(task, i) in tasks[tabs]">
                  <v-row
                    :key="i"
                    align="center"
                  >
                    <v-col cols="1">
                      <v-list-item-action>
                        <v-checkbox
                          v-model="task.value"
                          color="secondary"
                        />
                      </v-list-item-action>
                    </v-col>

                    <v-col cols="9">
                      <div
                        class="font-weight-light"
                        style="cursor: pointer"
                        v-text="task.text"
                        @click="showContents(task)"
                      />
                    </v-col>

                    <v-col
                      cols="2"
                      class="text-right"
                    >
                      <v-icon class="mx-1">
                        mdi-pencil
                      </v-icon>
                      <v-icon
                        color="error"
                        class="mx-1"
                      >
                        mdi-close
                      </v-icon>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </base-material-card>
      </v-col>
    </v-row>

    <!-- Tasks 팝업 -->
    <v-dialog
      v-model="dialog"
      max-width="800"
    >
      <v-card class="text-center">
        <v-card-title>
          {{ dialogTitle }}

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="dialog = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="text-left">
          <pre>{{ dialogContent }}</pre>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import dateUtil from '@/utils/dateUtil';
  import { formatNumberWithComma } from '@/utils/numberUtil.js';

  export default {
    name: 'DashboardDashboard',

    data () {
      return {
        dialog: false,
        dialogTitle: '',
        dialogContent: '',
        today : dateUtil.formatDate(new Date()),
        workday : '',
        kospiChart: {
          todayRatio: '0',
          isTodayUp: true,
          data: {
            labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            series: [
              [12, 17, 7, 17, 23, 18, 38],
            ],
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0,
            }),
            low: 0,
            high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
        },
        kosdaqChart: {
          todayRatio: '0',
          isTodayUp: true,
          data: {
            labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
            series: [
              [230, 750, 450, 300, 280, 240, 200, 190],
            ],
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0,
            }),
            low: 0,
            high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
        },
        emailsSubscriptionChart: {
          data: {
            labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],

            ],
          },
          options: {
            axisX: {
              showGrid: false,
            },
            low: 0,
            high: 1000,
            chartPadding: {
              top: 0,
              right: 5,
              bottom: 0,
              left: 0,
            },
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0]
                },
              },
            }],
          ],
        },
        headers: [
          {
            sortable: false,
            text: '종목코드',
            value: 'stkId',
          },
          {
            sortable: false,
            text: '종목명',
            value: 'stkName',
            align: 'left',
          },
          {
            sortable: false,
            text: '현재가',
            value: 'curPrice',
            align: 'right',
          },
        ],
        recommendStocks: [
          {
            stkId: 'Dakota Rice',
            stkName: 'Niger',
            curPrice: '100',
          },
        ],
        topTradingHeaders: [
          {
            sortable: false,
            text: '종목코드',
            value: 'stkId',
          },
          {
            sortable: false,
            text: '종목명',
            value: 'stkName',
            align: 'left',
          },
          {
            sortable: false,
            text: '현재가',
            value: 'price',
            align: 'right',
          },
          {
            sortable: false,
            text: '매수가',
            value: 'buyPrice',
            align: 'right',
          },
          {
            sortable: false,
            text: '매도가',
            value: 'sellPrice',
            align: 'right',
          },
          {
            sortable: false,
            text: '등락율',
            value: 'pricePercent',
            align: 'center',
          },
          {
            sortable: false,
            text: '거래량',
            value: 'qty',
            align: 'right',
          },
        ],
        topTradingStocks: [
          {
            stkId: 'Dakota Rice',
            stkName: 'Niger',
            price: '100',
            buyPrice: 100,
            sellPrice: 100,
            pricePercent: '1.35%',
            qty: '100',
          },
        ],
        topTradingSearchTime: '',
        tabs: 0,
        tasks: {
          0: [
            {
              text: 'Sign contract for "What are conference organizers afraid of?"',
              value: true,
            },
            {
              text: 'Lines From Great Russian Literature? Or E-mails From My Boss?',
              value: false,
            },
            {
              text: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              value: false,
            },
            {
              text: 'Create 4 Invisible User Experiences you Never Knew About',
              value: true,
            },
          ],
          1: [
            {
              text: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              value: true,
            },
            {
              text: 'Sign contract for "What are conference organizers afraid of?"',
              value: false,
            },
          ],
          2: [
            {
              text: 'Lines From Great Russian Literature? Or E-mails From My Boss?',
              value: false,
            },
            {
              text: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              value: true,
            },
            {
              text: 'Sign contract for "What are conference organizers afraid of?"',
              value: true,
            },
          ],
        },
        list: {
          0: false,
          1: false,
          2: false,
        },
      }
    },
    beforeDestroy() {
      this.$root.$off('logout-event', this.fetchRecStockByTopTrading); // 메모리 누수 방지
    },
    mounted() {
      this.$root.$on('logout-event', this.fetchRecStockByTopTrading);

      this.fetchRecommendStocks();      // 추천종목
      this.fetchRecStockByTopTrading(); // 거래량 상위종목
      this.fetchKospiRatio('KOSPI');
      this.fetchKospiRatio('KOSDAQ');
      this.fetchTechLibrary();

      const now = new Date();
      const hour = now.getHours();
      const minutes = now.getMinutes;
      this.topTradingSearchTime = 'Data inquiry time: ' + dateUtil.getCurrentDateTime();
      
      this.refreshInterval = setInterval(() => {
        const now = new Date();
        const hour = now.getHours();
        const minutes = now.getMinutes;
        this.topTradingSearchTime = 'Data inquiry time: ' + dateUtil.getCurrentDateTime();

        // 9시(9) 이상이고 16시(16) 이하일 때만 실행
        if (hour >= 9 && hour <= 16) {
          this.fetchKospiRatio('KOSPI');
          this.fetchKospiRatio('KOSDAQ');
          this.fetchRecStockByTopTrading();
        }
      }, 60000); // 1분 간격
    },
    beforeDestroy() {
      clearInterval(this.refreshInterval);
    },
    computed: {
      isLogin() {
        return this.$store.state.user.isLogin;
      }
    },
    methods: {
      async fetchKospiRatio(pChartName) {
        let chartName = 'kospiChart';
        if(pChartName === 'KOSDAQ'){
          chartName = 'kosdaqChart';
        }

        axios.get('/api/public/kospi-ratio?type=' + pChartName)
          .then(response => {
            
            const vKospiList = response.data.kospiList || [];

            if(vKospiList && vKospiList.length > 0){
              this[chartName].data.labels = vKospiList.map(x=>{return x.date.substring(5);}) || [];
              this[chartName].data.series = [vKospiList.map(x=>{return x.closePrice.replaceAll(',','');}).map(parseFloat)] || [];
              this[chartName].data.seriesTooltip = [vKospiList.map(x=>{return x.changeRate.replaceAll('%','');}).map(parseFloat)] || [];
              
              const prices = this[chartName].data.series.map(item => item.closePrice);
              const minPrice = Math.min(...prices);
              const maxPrice = Math.max(...prices);
              this[chartName].options.low = minPrice;
              this[chartName].options.high = maxPrice;
              const vTooltip = this[chartName].data.seriesTooltip[0];
              if(vTooltip && vTooltip.length > 0){
                this[chartName].todayRatio = vTooltip[vTooltip.length-1] + '';
                this[chartName].isTodayUp = (vTooltip[vTooltip.length-1] >= 0) ? true : false;
              }
              
              // ✅ Chartist 강제 리렌더링 유도
              setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
              }, 200);

              //console.log(chartName + '.data:', this[chartName].data);
            } else {
              this[chartName].data.labels = [];
              this[chartName].data.series = [];
              this[chartName].data.seriesTooltip = [];
              this[chartName].options.low = 0;
              this[chartName].options.high = 0;
              this[chartName].todayRatio = '0';
              //console.log(chartName + '.data else pass.....');
            }
          })
          .catch(error => {
            console.error('kospi지수 불러오기 실패:', error);
          });
      },
      async fetchRecommendStocks() {
        axios.get('/api/public/recommend-stocks')
          .then(response => {
            this.recommendStocks = response.data.map(x=>{
              x.curPrice = formatNumberWithComma (x.curPrice);
              return x;
            });
          })
          .catch(error => {
            console.error('추천 종목 불러오기 실패:', error);
          });
      },
      async fetchRecStockByTopTrading() {
        const vUrl = this.isLogin ? '/api/rec-stock-by-top-trading' : '/api/public/rec-stock-by-top-trading';
        const vToken = this.isLogin ? `Bearer ${sessionStorage.getItem('token')}` : 'Bearer null';
        
        // 거래량 상위
        axios.get(vUrl, {
          headers: {
            Authorization: vToken
          }
        })
        .then(response => {
          this.workday = dateUtil.formatDate(response.data.workday);
          this.topTradingStocks = response.data.list.map(x=>{
            x.price = formatNumberWithComma (x.price);
            x.qty = formatNumberWithComma (x.qty);
            x.pricePercent = x.pricePercent + '%';
            return x;
          });
        })
        .catch(error => {
          console.error('거래량 상위 불러오기 실패:', error);
        });
      },
      async fetchTechLibrary() {
        
        try {
          const response = await axios.get('/api/public/tech-library', {
            params: {
              currentPage: 1,
              pageSize: 10,
              searchKeyword: '',
              sortColumn: '',
              sortOrder: 'asc',
              searchType: ''
            }
          });
          
          const vFront = response.data.list.filter(x=>x.libType === 'FRONT').map(y=>{return {text: y.libTitle, value: false, content: y.libContent};});
          const vBackend = response.data.list.filter(x=>x.libType === 'BACKEND').map(y=>{return {text: y.libTitle, value: false, content: y.libContent};});
          this.tasks[0] = vFront || [];
          this.tasks[1] = vBackend || [];
          
        } catch (error) {
          console.error('기술자료 불러오기 실패:', error);
        }

      },
      showContents(params){
        //console.log('showContents', params);
        this.dialogTitle = params.text || '';
        this.dialogContent = params.content || '';
        this.dialog = true;
      },
      complete (index) {
        this.list[index] = !this.list[index]
      },
    },  
    
  }
</script>
